/**
 * Hash-based trust page navigation (no react-router dependency).
 * Explore = "" or "#/" ; documents = "#/privacy" etc.
 */

import { TRUST_PAGES } from "./trustContent";

export const EXPLORE_PAGE_ID = "explore";

export function isTrustPageId(id) {
  return Boolean(id && TRUST_PAGES[id]);
}

export function trustHashFor(pageId) {
  if (!pageId || pageId === EXPLORE_PAGE_ID) return "#/";
  return `#/${pageId}`;
}

export function parseTrustPageId(hash = window.location.hash) {
  const raw = String(hash || "")
    .replace(/^#/, "")
    .replace(/^\//, "")
    .split(/[?/]/)[0]
    .trim()
    .toLowerCase();

  if (!raw || raw === "explore" || raw === "home") return EXPLORE_PAGE_ID;
  if (isTrustPageId(raw)) return raw;
  return EXPLORE_PAGE_ID;
}

export function getTrustPage(pageId) {
  return isTrustPageId(pageId) ? TRUST_PAGES[pageId] : null;
}
